<div class="row align-items-center mb-3">
  <div class="col-auto">
    <input type="checkbox" [(ngModel)]="openClientFileManager" id="openClientFileManager">
  </div>
  <div class="col">
    <label for="openClientFileManager" class="mb-0">Enable Client File Manager</label>
  </div>
</div>
@if (availableDocuments && availableDocuments.length>0) {
  <div class="_wf-historyheading-epricription">
    <div class="mb-1 history-label">Count ({{pagination.count?pagination.count:0}})</div>
    <div class="select-file-css">
      <label for="{{uniqueString}}" class="m-0" (click)="onSelectFile($event)">
        <i class="upload-icon fa fa-upload kx-grey-txt-80" aria-hidden="true"></i>
        <span>&nbsp;Select File</span>
      </label>
      <input type="file" style="display:none;" id="{{uniqueString}}" (change)="onChange($event)" title="Select file"
        name="files[]" [accept]="'.jpg,.jpeg,.png,.Png'" [multiple]="true" />
    </div>
    <div class="d-flex">
      <div class="_wf-buttonfornextprev _wf-buttonfornextprev2" [ngClass]="pagination.page_no==0 ? 'errors' : '' "
        (click)="goPrev() "><i class="fa fa-angle-left"></i>{{'field.label.Previous' | translate | async }}</div>
        <div class="_wf-buttonfornextprev" [ngClass]="getClassToEnableDisableIcon()" (click)="goNext()">
          {{'button.label.next' | translate | async}}<i class="fa fa-angle-right"></i></div>
        </div>
      </div>
    }
    <div class="overflow-auto text-nowrap px-4 my-4 table-responsive">
      @for (document of availableDocuments; track document) {
        <div class="text-center rounded imageContainer d-inline-block"
          (click)="viewImage(document)">
          <img class="text-center" [src]="document.imageUrl | secure  | async" alt="{{document.imageName}}" [width]="120"
            [height]="120">
        </div>
      }
    </div>
    @if (question && question.type && question.type == 'array' && tempArray && tempArray.length > 0) {
      <div class="overflow-auto text-nowrap mb-2 mt-2 table-responsive">
        <h3>Selected Documents</h3>
        <ul class="selctimageContainer" (dragover)="onDragOverContainer($event)" (drop)="onDropInContainer($event)">
          @for (document of tempArray; track document; let i = $index) {
            <li draggable="true" class="text-center rounded imageContainerselct d-inline-block"
              (dragstart)="onDragStart($event, i)"
              (dragover)="onDragOverItem($event, i)"
              (drop)="onDropOnItem($event, i)"
              (dragend)="onDragEnd($event)"
              >
              <img [attr.src]="document.imageUrl | secure  | async" alt="{{document.documentName}}" [width]="126"
                [height]="90" >
              <div class="sequence-badge">{{ i + 1 }}</div>
              <div class="selimgdelticon">
                <i class="fa fa-trash" (click)="deleteDoc(document, i)"></i>
              </div>
            </li>
          }
        </ul>
      </div>
    }


    @if (isComponentArrayType) {
      <div class="overflow-auto text-nowrap mb-2 mt-2 table-responsive w-50">
        @for (cropData of cropQueue; track cropData; let idx = $index) {
          <div>
            @if (cropData.showCropper) {
              <image-cropper
                [imageChangedEvent]="cropData.imageChangedEvent"
                [maintainAspectRatio]="false"
                [aspectRatio]="4 / 3"
                [format]="cropData.format || 'png'"
                (imageCropped)="onImageCropped($event, idx)"
                >
              </image-cropper>
            }
            @if (cropData.showCropper) {
              <button class="primary-btn" (click)="confirmCrop(idx)">Confirm Crop</button>
            }
          </div>
        }
      </div>
    }

    @if (selectedDocument) {
      <div class="col-12 col-sm-12 col-md-12 border rounded text-center thumbViewer">
        <diacom-viewer (documentDetails)="processDocument($event,selectedDocument)"
        [config]="{url:(selectedDocument.image ? selectedDocument.image : selectedDocument.imageUrl), type:selectedDocument.filetype ? selectedDocument.filetype : 'file', contentType:'image/png',key:question!=undefined && question.key!=undefined?question.key:''}"></diacom-viewer>
      </div>
    }